import type { Variants } from 'framer-motion';

const SIDEBAR_EASING: [number, number, number, number] = [0.4, 0, 0.2, 1];

const sidebarVariants = {
  open: {
    width: 300,
    marginRight: 16,
    opacity: 1,
    transition: {
      width: { duration: 0.3, ease: SIDEBAR_EASING },
      marginRight: { duration: 0.3, ease: SIDEBAR_EASING },
      opacity: { duration: 0.25, ease: SIDEBAR_EASING },
    },
  },
  closed: {
    width: 0,
    marginRight: 0,
    opacity: 0,
    transition: {
      width: { duration: 0.25, ease: SIDEBAR_EASING },
      marginRight: { duration: 0.25, ease: SIDEBAR_EASING },
      opacity: { duration: 0.2, ease: SIDEBAR_EASING },
    },
  },
} satisfies Variants;

export { sidebarVariants };
